import MassActivateCardsPage from './MassActivateCardsPage';

export default MassActivateCardsPage;
